import { render, staticRenderFns } from "./fa-IR.vue?vue&type=template&id=5e90a42c&"
import script from "./fa-IR.vue?vue&type=script&lang=js&"
export * from "./fa-IR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e90a42c')) {
      api.createRecord('5e90a42c', component.options)
    } else {
      api.reload('5e90a42c', component.options)
    }
    module.hot.accept("./fa-IR.vue?vue&type=template&id=5e90a42c&", function () {
      api.rerender('5e90a42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/fa-IR.vue"
export default component.exports